import { POST_STATUS } from 'utils/Constants';
import Client from './baseClient';
const http = new Client(process.env.REACT_APP_BACKEND_URL);

// /user/search-by-phone
export const searchByPhone = (data) => {
  return http.post(`api/user/search-by-phone`, data);
};

export const verifyPhone = (data) => {
  let phone = data.replace('+', '%2B');
  let url = `api/user/phoneRegistered?phoneNumber=${phone}`;
  return http.get(url);
};
export const deleteAccount = (data) => {
  let url = `api/user/delete`;

  return http.post(url, data);
};

export const getPlotByIDCompact = (id, config) => {
  return http.get(
    'api/plot/' + id + '/public?getClosePlots=true&includeDisputes=true',
    config,
  );
};

export const getPlotByRectanglePublic = (data, config = {}) => {
  return http.post('api/claimchain/by-rectangle/public', data, config);
};

export const getAllPlot = ({ idPlot = '', page = 1, perPage = 10 }) => {
  return http.get(
    `api/admin/all-plots?page=${page}&perPage=${perPage}&search=${idPlot}`,
    '',
  );
};

export const getNeighborByPlotID = (id) => {
  return http.get(`api/neighbor/${id}`);
};

export const getPlotBoundaryImage = (id) => {
  return http.get(`api/plot/${id}/all-boundary`);
};
export const getClaimchainByPlotID = (id, config) => {
  return http.get('api/claimchain/plot/' + id, config);
};

export const getDashboardData = (year = new Date().getFullYear(), dispatch) => {
  return http.get('api/admin/reports?year=' + year, null, dispatch);
};

export const resetTestEnvironment = () => {
  return http.post('api/admin/better-way');
};

export const getPlotsActivity = (
  { page = 1, perPage = 10, search },
  dispatch,
) => {
  return http.get(
    'api/admin/plot-activity?page=' +
      page +
      '&perPage=' +
      perPage +
      '&search=' +
      search,
    null,
    dispatch,
  );
};

export const getServerInfo = () => {
  return http.get('api/version');
};

export const getFlaggedPlots = (dispatch) => {
  return http.get(`api/admin/flag-plots`, null, dispatch);
};

export const flaggedPlotByPlotName = (name) => {
  return http.delete(`api/admin/flag-plots/` + name);
};

export const unflaggedPlotByPlotName = (name) => {
  return http.post(`api/admin/flag-plots/` + name);
};

export const getPlotsByRectangleLimited = (data, config) => {
  return http.post('api/claimchain/by-rectangle/public/limited', data, config);
};

export const getCenterLargestClaimChain = (data, navigation, dispatch) => {
  return http.get(
    'api/claimchain/largest-claimchain',
    data,
    navigation,
    {},
    dispatch,
  );
};

export const getFlaggedPlotInfoByName = (name) => {
  return http.get(`api/plot/get-flagged-plot/by-name/` + name);
};

export const getCluster = (country = 'UGA') => {
  return http.get(`api/plot/get-all-centroids?countryCode=${country}`);
};
export const getCountCluster = (country = 'UGA') => {
  return http.get(
    `api/plot/get-all-centroids?countOnly=true&countryCode=${country}`,
  );
};

export const getClaimchainLimit = (data, config) => {
  return http.post('api/claimchain/public/limited', data, config);
};

export const getS3Image = (key) => {
  let _key = encodeURI(key);
  return http.get('api/services/s3?imageAWSKey=' + _key);
};

// api/admin/contract
export const getContractData = (year) => {
  return http.get(`api/admin/contract?year=${year}`);
};

// Liquidity pool
// api/admin/pool
export const createPool = (data) => {
  return http.post(`api/admin/pool`, data);
};

export const getPool = (id) => {
  return http.get(`api/admin/pool?id=${id}`);
};

// api/admin/pool/deposit
export const depositPool = (data) => {
  return http.post(`api/admin/pool/deposit`, data);
};

// api/admin/pool/toggle
export const togglePool = (data) => {
  return http.put(`api/admin/pool/toggle`, data);
};

// api/admin/pool/add-user
export const addUserToPool = (data) => {
  return http.post(`api/admin/pool/add-user`, data);
};

// api/admin/pool/disable-user
export const disableUserInPool = (data) => {
  return http.put(`api/admin/pool/disable-user`, data);
};

// /pool/details/:id
export const getPoolDetails = (id, year) => {
  let url = `api/admin/pool/details/${id}`;
  if (year) {
    url += `?year=${year}`;
  }
  return http.get(url);
};
// /pool/details/:id/transfer-loan
export const getPoolTransferLoan = (id) => {
  return http.get(`api/admin/pool/details/${id}/transfer-loan`);
};

// /pool/details/:id/investment
export const getPoolInvestment = (id) => {
  return http.get(`api/admin/pool/details/${id}/investment`);
};
// /pool/details/:id/repayment
export const getPoolRepayment = (id) => {
  return http.get(`api/admin/pool/details/${id}/invoices`);
};
// /update-pool/:poolId
export const updatePool = (poolId, data) => {
  return http.put(`api/admin/update-pool/${poolId}`, data);
};
// /pool/edit-user
export const editUserInPool = (data) => {
  return http.put(`api/admin/pool/edit-user`, data);
};
export const getSecretQuestion = () => {
  return http.get('api/user/secret-question');
};

// /admin/review-users
export const getReviewUsers = () => {
  return http.get(`api/admin/review-users`);
};
// POST /admin/review-users
export const reviewUser = (data) => {
  return http.post(`api/admin/review-users`, data);
};
// /user/all
export const getAllUser = ({
  page = 1,
  perPage = 10,
  isUnderReview = false,
  phoneNumber = '',
  isBanned = false,
}) => {
  return http.get(
    `api/admin/users/all?page=${page}&perPage=${perPage}&isUnderReview=${isUnderReview}&phoneNumber=${encodeURIComponent(
      phoneNumber,
    )}&isBanned=${isBanned}`,
  );
};
// /admin/users/{id}
export const getUserDetail = (id) => {
  return http.get(`api/admin/users/${id}`);
};
// /admin/update-secret-question
export const updateSecretQuestion = (data) => {
  return http.post(`api/admin/update-secret-question`, data);
};

// api/admin/detect-bad-guys
export const fetchBadGuys = (id = null, page = 1, perPage = 10, name) => {
  let url = id
    ? `api/admin/detect-bad-guys/${id}`
    : `api/admin/detect-bad-guys`;
  if (page) {
    url += `?page=${page}`;
  }
  if (perPage) {
    url += `&perPage=${perPage}`;
  }
  if (name) {
    url += `&name=${name}`;
  }
  return http.get(url);
};

// POST api/admin/detect-bad-guys
export const detectBadGuys = (data) => {
  return http.post(`api/admin/detect-bad-guys`, data);
};

// api/admin/detect-bad-guys/status
export const detectBadGuysStatus = () => {
  return http.get(`api/admin/detect-bad-guys/status`);
};

// api/admin/currency
export const getCurrency = () => {
  return http.get(`api/admin/currency`);
};

// POST /location-config
export const createLocationConfig = (data) => {
  return http.post(`api/admin/location-config`, data, {});
};

// /location-config/all
export const getLocationConfig = ({ perPage = 1000000000 }) => {
  return http.get(`api/admin/location-config/all?perPage=${perPage}`);
};

export const getAuthenticator = (id) => {
  return http.get(`api/admin/authenticator?locationConfigId=${id}`);
};

export const addUserToAuthenticatorWhitelist = (data) => {
  return http.post(`api/admin/authenticator`, data);
};

export const revokeUserFromAuthenticatorWhitelist = (data) => {
  return http.post(`api/admin/remove-authenticator`, data);
};
// POST /api/admin/request-new-pof / const { userId } = req.body;
export const requestNewPof = (data = { userId: '' }) => {
  return http.post(`api/admin/request-new-pof`, data);
};

export const uploadFile = async (data, url, isMock = false) => {
  if (isMock) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({ url: 'https://picsum.photos/200/300' });
      }, 1000);
    });
  }

  const formData = new FormData();
  formData.append('file', data);
  const res = await http.post(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return res.data;
};
// POST /api/admin/merge-account
export const mergeAccount = (data) => {
  return http.post(`api/admin/merge-account`, data);
};
